// Lux Coffee: om-sidornas byggstenar. Bildväxlaren (01 02 03) i lux-editorial
// och pilarna för tidslinjen i lux-card-row. Laddas av sektionerna (defer);
// varje element kopplas bara en gång, även om filen tas med flera gånger.
(function () {
  "use strict";
  if (window.luxAbout) return;
  window.luxAbout = true;

  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var once = function (el) { if (el.dataset.luxAbout) return false; el.dataset.luxAbout = "1"; return true; };

  var initSlides = function (root) {
    $$("[data-ab-slides]", root).forEach(function (box) {
      if (!once(box)) return;
      var dots = $$("[data-ab-slide]", box);
      var imgs = $$("[data-ab-slide-img]", box);
      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          dots.forEach(function (d, k) { d.setAttribute("aria-pressed", String(k === i)); });
          imgs.forEach(function (img, k) { img.hidden = k !== i; });
        });
      });
    });
  };

  var initRails = function (root) {
    $$("[data-ab-rail-wrap]", root).forEach(function (wrap) {
      if (!once(wrap)) return;
      var rail = wrap.querySelector("[data-ab-rail]");
      var prev = wrap.querySelector("[data-ab-prev]");
      var next = wrap.querySelector("[data-ab-next]");
      if (!rail || !prev || !next) return;
      var step = function () {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || 0) : 300;
      };
      var update = function () {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      };
      prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
      next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
      rail.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  };

  var init = function (root) { initSlides(root); initRails(root); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); });
  else init(document);

  // Temaredigeraren: koppla om sektioner som laddas om
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
